import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export const GET_HTML_PLACEHOLDERS_QUERY_KEY = 'get-html-placeholders';

export const useGetHtmlPlaceholdersQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_HTML_PLACEHOLDERS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/html-components/placeholders`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? undefined }) as Promise<
        Record<string, { path: string; description: string }>
      >;
    },
  });
};
